import { Tabs } from '@zorro/design-system/v2/Tabs';
import {
  PaymentsProviderBadge,
  usePaymentsProvider,
} from '@zorro/web/shared-ui';
import { useAppRouter, useMonolithQuery, useRoles } from '@zorro/web/ui-utils';

import {
  EmployeePageTabType,
  getEmployeePageTabConfig,
  getEmployeePageTabs,
} from './EmployeePageTabsUtils';

type Props = {
  onboardingPeriodId: string;
  tab: EmployeePageTabType;
  employerId: string;
  employeeId: string;
  isDon: boolean;
};

export const EmployeePageTabs = ({
  onboardingPeriodId,
  employerId,
  employeeId,
  isDon,
  tab,
}: Props) => {
  const { navigateToRoute } = useAppRouter();
  const { isOmnipotentAdmin } = useRoles();
  const { paymentsProvider } = usePaymentsProvider(employerId);

  const { data: onboardingPeriod } = useMonolithQuery({
    method: 'onboardingPeriodReportsControllerGenerateOnboardingPeriodReport',
    params: [onboardingPeriodId],
  });

  const allTabs = getEmployeePageTabs(isDon, onboardingPeriod);

  const paymentsProviderBadge = isOmnipotentAdmin && paymentsProvider && (
    <PaymentsProviderBadge paymentsProvider={paymentsProvider} />
  );

  return (
    <Tabs value={tab} keepMounted={false}>
      <Tabs.List>
        {allTabs.map((newTab) => {
          const { label, isDisabled, route, rightSection } =
            getEmployeePageTabConfig(
              newTab,
              isDon,
              onboardingPeriod,
              paymentsProviderBadge
            );

          return (
            <Tabs.Tab
              onClick={() =>
                navigateToRoute(route, [
                  { employerId, employeeId, onboardingPeriodId },
                ])
              }
              disabled={!onboardingPeriod || isDisabled}
              value={newTab}
              key={newTab}
              rightSection={rightSection}
            >
              {label}
            </Tabs.Tab>
          );
        })}
      </Tabs.List>
    </Tabs>
  );
};
